import "./HeroImgStyles.css";
import IntroImg from "../assets/code.jpg"
import React from "react";
import { Link } from "react-router-dom";

const HeroImg = () => {
  return <div className="hero">
    <div className="mask">
      <img className="into-img" src={IntroImg} alt="IntroImg"/>
    </div>
    <div className="content">
      <p>Hola, Futuro Ing. de Software!</p>
      <h1>Desarrollador Jr.</h1>
      <div>
        <Link to="/project" className="btn">Proyectos</Link>
        <Link to="/contact" className="btn btn-light">Contacto</Link>
      </div>
    </div>
  </div>;
};

export default HeroImg;
